import {
  IManagerLegacyNavTranslations,
  IEventManagerHomeTranslations,
  IEventManagerExhibitorsTranslations,
  IEventManagerProductsTranslations,
  IEventManagerSessionsTranslations,
  IEventManagerExportsTranslations,
  IEventManagerEventsTranslations,
  IManagerTranslations,
} from '@/translations/default/managers';

const legacy_nav: Partial<IManagerLegacyNavTranslations> = {
  product_form: 'Formulário de produtos',
  product_list: 'Lista de produtos',
  product_categories: 'Categorias de produtos',
};

const home: Partial<IEventManagerHomeTranslations> = {
  products_subtitle: 'Número de produtos criadas',
};

const exhibitors: Partial<IEventManagerExhibitorsTranslations> = {
  products_limit_label: 'Limite de produtos',
  products_limit_message: 'Número máximo de produtos que este expositor pode criar',
};

const products: Partial<IEventManagerProductsTranslations> = {
  empty_list_form_subtitle: 'Criar o formulário de oferta de emprego',
  empty_list_categories_subtitle: 'Adicionar categorias de produtos',
  empty_list_product_title: 'Produtos',
  empty_list_product_subtitle: 'Criar um produto novo',
  title: 'Produtos disponíveis',
  subtitle: 'Número de produtos criadas',
};

const sessions: Partial<IEventManagerSessionsTranslations> = {
  // leave empty until needed
};

const exports: Partial<IEventManagerExportsTranslations> = {
  // leave empty until needed
};

const events: Partial<IEventManagerEventsTranslations> = {
  // leave empty until needed
};

const managers: DeepPartial<IManagerTranslations> = {
  legacy_nav,
  home,
  exhibitors,
  products,
  sessions,
  exports,
  events,
};

export default managers;
